import { Component, OnInit, OnDestroy, ChangeDetectorRef, signal, inject, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { AppService } from '../../core/service/app.service';
import { HeaderService } from '../../core/service/header.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MenuModule } from 'headlessui-angular';
import { FormsModule } from '@angular/forms';
import { NgClass, AsyncPipe, CommonModule } from '@angular/common';
import { distinctUntilChanged, map, Subject, switchMap, takeUntil } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { SharedModule } from '../../shared/shared.module';
import { AuthService } from '../../auth/auth.service';
import { TenantService } from '../../core/service/tenant.service';
import { TenantSwitchService } from '../../core/service/tenant-switch.service';
import { AlertService } from '../../core/service/alert.service';
import { HttpParams } from '@angular/common/http';
import { ImageService } from '../../core/service/image.service';
import { UserService } from 'src/app/pages/vendor/services/user.service';
import { UserProfileStateService } from 'src/app/core/service/user-profile-state.service';
import { environment } from 'src/environments/environment';
import { IconPurchaseComponent } from '@app/shared/icon/purchase-master/icon-purchase';
import { NotificationMasterService } from '@app/pages/notification-master/service/notification-master.service';
import { NotificationComponent } from '../notification/notification.component';
import { NotificationMetaData } from '@app/pages/notification-master/notification-list/interface/notification.list.interface';
import { PermissionService } from '../../core/service/permission.service';
import { HasPermissionDirective } from '../../core/directives/has-permission.directive';
@Component({
    selector: 'header',
    templateUrl: './header.html',
    animations: [
        trigger('toggleAnimation', [
            transition(':enter', [style({ opacity: 0, transform: 'scale(0.95)' }), animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))]),
            transition(':leave', [animate('75ms', style({ opacity: 0, transform: 'scale(0.95)' }))]),
        ]),
    ],
    standalone: true,
    imports: [
        CommonModule,
        NgClass,
        RouterLink,
        FormsModule,
        MenuModule,
        TranslateModule,
        SharedModule,
        AsyncPipe,
        NotificationComponent,
        HasPermissionDirective,
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {
    private readonly destroy$ = new Subject<void>();
    store: any;
    search = false;
    headerConfig$ = this.headerService.headerConfig$;

    // Tenant management
    tenants: any[] = [];
    selectedTenant: any;
    tenantOptions: any[] = [];
    selectedTenantOption: any = null;
    vendorData: any = {};
    profile_picture: string = '';
    userProfile = this.userProfileState.userProfile;
    showActivityMenu = signal(true);
    notifications: Array<NotificationMetaData> = [];
    selectedNotifTab = signal<string>('all');
    userProfileImageUrl = '';
    private readonly injector = inject(Injector);
    messages = [
        {
            id: 1,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-success-light dark:bg-success text-success dark:text-success-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></span>`
            ),
            title: 'Congratulations!',
            message: 'Your OS has been updated.',
            time: '1hr',
        },
        {
            id: 2,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-info-light dark:bg-info text-info dark:text-info-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`
            ),
            title: 'Did you know?',
            message: 'You can switch between artboards.',
            time: '2hr',
        },
        {
            id: 3,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-danger-light dark:bg-danger text-danger dark:text-danger-light"> <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>`
            ),
            title: 'Something went wrong!',
            message: 'Send Reposrt',
            time: '2days',
        },
        {
            id: 4,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-warning-light dark:bg-warning text-warning dark:text-warning-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">    <circle cx="12" cy="12" r="10"></circle>    <line x1="12" y1="8" x2="12" y2="12"></line>    <line x1="12" y1="16" x2="12.01" y2="16"></line></svg></span>`
            ),
            title: 'Warning',
            message: 'Your password strength is low.',
            time: '5days',
        },
    ];
    get filteredNotifications() {
        const list = this.notifications ?? [];
        if (this.selectedNotifTab() === 'read') return list.filter((n: NotificationMetaData) => n.read);
        if (this.selectedNotifTab() === 'unread') return list.filter((n: NotificationMetaData) => !n.read);
        if (this.selectedNotifTab() === 'all') return list;
        return [];
    }

    /** True when at least one notification is unread — drives the header bell badge. */
    get hasUnreadNotifications(): boolean {
        return (this.notifications ?? []).some((n) => !n.read);
    }

    private normalizeReadFlag(value: unknown): boolean {
        if (value === true || value === 1) return true;
        if (value === false || value === 0 || value == null) return false;
        if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'true' || v === '1') return true;
            if (v === 'false' || v === '0' || v === '') return false;
        }
        return Boolean(value);
    }
    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
        private readonly appSetting: AppService,
        private readonly sanitizer: DomSanitizer,
        public headerService: HeaderService,
        private readonly authService: AuthService,
        private readonly tenantService: TenantService,
        private readonly tenantSwitchService: TenantSwitchService,
        private readonly alertService: AlertService,
        private readonly cdr: ChangeDetectorRef,
        public imageService: ImageService,
        private readonly userService: UserService,
        private readonly userProfileState: UserProfileStateService,
        private readonly notificationService: NotificationMasterService,
        public permissionService: PermissionService
    ) {}
    initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    ngOnInit() {
        this.initStore();
        if (this.permissionService.allPermissions().length === 0) {
            void this.permissionService.loadPermissions();
        }
        this.initializeTenantFromStorage();
        this.initializeComponent();
        this.fetchNotifications();
        this.setupSubscriptions();
        this.setActiveDropdown();
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Initialize tenant from localStorage on component load
     */
    private initializeTenantFromStorage(): void {
        const storedTenantId = localStorage.getItem('currentTenantId') || '';
        if (storedTenantId && storedTenantId !== 'undefined' && storedTenantId !== 'select_tenant') {
            this.selectedTenant = storedTenantId;
            // Will be set properly after tenants are loaded
        }
    }

    /**
     * Initialize core component data
     */
    private initializeComponent(): void {
        this.vendorData = this.authService.getVendorData();
        this.profile_picture = this.vendorData?.profile_picture || '';
        this.watchUserProfileForAvatar();
        // Extract tenant access from vendor data
        const accesses = this.vendorData?.vendor_tenant_access || [];
        if (accesses.length > 0) {
            this.tenants = this.accessTenantList(accesses);
            if (this.tenants.length > 0) {
                const existingTenantData = this.authService.getTenantDataValue();
                this.authService.setTenantInfo(existingTenantData || this.tenants[0]);
            }
            // Initialize tenant with improved logic
            setTimeout(() => {
                this.initializeTenantsAfterDataLoad();
            }, 100);
        }
    }

    /**
     * Setup all subscriptions with proper cleanup
     */
    private setupSubscriptions(): void {
        // Tenant refresh subscription
        this.authService.tenantRefresh$.pipe(takeUntil(this.destroy$)).subscribe((shouldRefresh) => {
            if (shouldRefresh) {
                this.handleTenantRefresh();
            }
        });

        // Tenant service subscription
        this.tenantService.tenant$.pipe(takeUntil(this.destroy$)).subscribe((tenantId) => {
            if (tenantId !== this.selectedTenant) {
                this.selectedTenant = tenantId;
                this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === tenantId) || null;
            }
            if (!tenantId && this.tenants?.length > 0) {
                const firstTenant = this.tenants[0];
                if (firstTenant?.tenant_subdomain) {
                    setTimeout(() => {
                        this.tenantService.setCurrentTenant(firstTenant.tenant_subdomain);
                    }, 100);
                }
            }
            this.cdr.detectChanges();
        });
    }

    /**
     * Handle tenant refresh with proper error handling
     */
    private handleTenantRefresh(): void {
        try {
            this.vendorData = this.authService.getVendorData();
            const accesses = this.vendorData?.vendor_tenant_access || [];
            this.tenants = this.accessTenantList(accesses);

            if (this.tenants.length > 0) {
                this.authService.setTenantInfo(this.tenants[0]);

                const currentTenant = this.tenants.find((tenant: any) => tenant?.tenant_subdomain === this.authService.getTenantDataValue()?.tenant_subdomain);

                if (currentTenant) {
                    localStorage.setItem('currentTenantId', currentTenant.tenant_subdomain);
                    this.selectedTenant = currentTenant.tenant_subdomain;
                    this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === currentTenant.tenant_subdomain) || null;
                    this.tenantService.tenantSubject.next(currentTenant.tenant_subdomain);
                }
            }

            this.cdr.detectChanges();
        } catch (error) {
            this.handleError(error, 'tenant refresh');
        }
    }

    /**
     * Initialize tenant selection after vendor data is loaded
     */
    private initializeTenantsAfterDataLoad(): void {
        const storedTenantId = localStorage.getItem('currentTenantId') || '';
        if (this.isValidStoredTenant(storedTenantId)) {
            this.setActiveTenant(storedTenantId);
            return;
        }

        if (this.tenants && this.tenants.length > 0) {
            const firstTenant = this.tenants[0];
            this.setActiveTenant(firstTenant.tenant_subdomain);
            return;
        }

        this.selectedTenant = '';
        this.selectedTenantOption = null;
    }

    /**
     * Get selected tenant name for display
     */
    getSelectedTenantName(): string {
        if (this.selectedTenantOption) {
            return this.selectedTenantOption.label || this.selectedTenantOption.value || '';
        }
        const tenant = this.tenants.find((t: any) => t.tenant_subdomain === this.selectedTenant);
        return tenant?.tenant_name || 'Select Tenant';
    }

    /**
     * Check if the stored tenant ID is valid
     */
    private isValidStoredTenant(storedTenantId: string): boolean {
        if (!storedTenantId || storedTenantId === 'undefined' || storedTenantId === 'select_tenant') {
            return false;
        }

        return this.tenants.some((tenant: any) => tenant.tenant_subdomain === storedTenantId);
    }

    /**
     * Set the active tenant
     */
    private setActiveTenant(tenantId: string): void {
        this.selectedTenant = tenantId;
        this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === tenantId) || null;
        this.tenantService.setCurrentTenant(tenantId);
        this.cdr.detectChanges();
    }

    accessTenantList(accesses: any) {
        this.tenants = accesses.map((item: any) => ({
            id: item.tenant_info.id,
            tenant_name: item.tenant_info.tenant_name,
            tenant_subdomain: item.tenant_info.tenant_subdomain,
            email: item.tenant_info.email,
            logo: item.tenant_info.logo,
        }));

        // Map tenants to dropdown options format
        this.tenantOptions = this.tenants.map((tenant: any) => ({
            value: tenant.tenant_subdomain,
            label: tenant.tenant_name,
        }));

        // Update selected option if tenant is already selected
        if (this.selectedTenant) {
            this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === this.selectedTenant) || null;
        }

        return this.tenants;
    }

    /**
     * Handle tenant change with improved error handling
     */
    async onTenantChange(selectedOption: any): Promise<void> {
        const selectedValue = typeof selectedOption === 'object' ? selectedOption.value : selectedOption;

        // Prevent multiple simultaneous switches
        if (this.tenantSwitchService.isSwitching()) {
            return;
        }

        try {
            const result = await this.tenantSwitchService.safeSwitchTenant(
                selectedValue,
                this.tenants,
                true // Navigate automatically for manual switches
            );

            if (!result.success) {
                // Reset to previous value on failure
                const currentTenantId = localStorage.getItem('currentTenantId') || '';
                this.selectedTenant = currentTenantId;
                this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === currentTenantId) || null;
            } else {
                // Update UI state after successful switch
                this.selectedTenant = selectedValue;
                this.selectedTenantOption = selectedOption;
                this.cdr.detectChanges();
            }
        } catch (error) {
            this.handleError(error, 'tenant change');

            // Reset to previous value on error
            const currentTenantId = localStorage.getItem('currentTenantId') || '';
            this.selectedTenant = currentTenantId;
            this.selectedTenantOption = this.tenantOptions.find((option: any) => option.value === currentTenantId) || null;
        }
    }

    /**
     * Handle error logging and user notification
     */
    private handleError(error: any, context: string): void {
        if (this.alertService) {
            this.alertService.showAlert('Error', `Failed to ${context}. Please try again.`, 'error');
        }
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    removeMessage(value: number) {
        this.messages = this.messages.filter((d) => d.id !== value);
    }

    changeLanguage(item: any) {
        this.translate.use(item.code);
        this.appSetting.toggleLanguage(item);
        if (this.store.locale?.toLowerCase() === 'ae') {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
        } else {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
        }
        window.location.reload();
    }

    goBack() {
        console.log('goBack');
    }

    getParams(): HttpParams {
        let params = new HttpParams().append('filter', this.selectedNotifTab());

        return params;
    }

    navigateToTenant() {
        this.router.navigate(['/tenant']).catch((error) => {
            console.error('Navigation error:', error);
        });
    }

    navigateToCategoryManagement() {
        this.router.navigate(['/category-master/category-list']).catch((error) => {
            console.error('Navigation error:', error);
        });
    }

    private watchUserProfileForAvatar(): void {
        toObservable(this.userProfile, { injector: this.injector })
            .pipe(
                takeUntil(this.destroy$),
                map((p) => p ?? this.authService.getVendorData()),
                distinctUntilChanged((a, b) => a?.id === b?.id && JSON.stringify(a?.profile_picture ?? null) === JSON.stringify(b?.profile_picture ?? null)),
                switchMap((u) => {
                    this.vendorData = u;
                    this.profile_picture = u?.profile_picture;
                    return this.imageService.resolveSuperAdminUserProfileImageUrl(u);
                })
            )
            .subscribe({
                next: (url) => {
                    this.userProfileImageUrl = url;
                    this.cdr.markForCheck();
                },
                error: (error) => {
                    console.error('Error loading profile image:', error);
                    this.userProfileImageUrl = '';
                },
            });
    }

    signOut() {
        this.authService.logout();
        this.router.navigate(['/auth/signin']);
    }

    /**Notifications */
    notificationType(type: string) {
        switch (type) {
            case 'read':
            case 'unread':
            case 'all':
                this.selectedNotifTab.set(type);
                this.fetchNotifications();
                break;
            default:
                this.fetchNotifications();
        }
    }

    fetchNotifications() {
        this.showActivityMenu.set(true);
        this.notificationService.fetchNotifications(this.getParams()).subscribe({
            next: (res: any) => {
                if (res?.status) {
                    this.notifications = (res?.data?.allAlerts ?? []).map((notification: any) => ({
                        id: notification?.id,
                        alert_type: notification?.alert_type,
                        title: notification?.title,
                        meta: notification?.meta_data,
                        read: this.normalizeReadFlag(notification?.is_read),
                        message: notification?.message,
                        iconCmp: IconPurchaseComponent,
                        created_at: notification?.created_at,
                    }));
                }
            },
            error: (error: any) => {
                this.alertService.showAlert('Error', error.error.messagee || error.error.error, 'error');
            },
        });
    }

    closeNotificationPopup() {
        this.showActivityMenu.set(false);
    }

    navigateToNotificationList() {
        this.router.navigate(['/notification-master/notification']);
    }
}
